import GrowthBookExperiment from "./GrowthBookExperiment";

class ChangeHeaderCTA extends GrowthBookExperiment {
	constructor(growthbook) {
		super(growthbook);
		this.run();
	}


	run() {
		if( growthbook_args.settings.feature_value && growthbook_args.settings.experiment_name) {
			const appVersion = this.growthbook.getFeatureValue(growthbook_args.settings.experiment_name);
			if (growthbook_args.settings.feature_value === appVersion) {
				this.replaceHeaderCtaLinks();
			}
		}

	}

	replaceHeaderCtaLinks() {
		const headerCtaButton = document.querySelector('.c-header .c-button--primary');
		if (!headerCtaButton) {
			return;
		}

		if (growthbook_args.settings.header_button_title) {
			headerCtaButton.innerText = growthbook_args.settings.header_button_title;
		}

		if (growthbook_args.settings.header_button_url) {
			headerCtaButton.href = growthbook_args.settings.header_button_url;
		}
	}

}

export default ChangeHeaderCTA;